import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://localhost:8000";
// export const filesURL = "http://localhost:8000/temporary";

export const baseURL = "https://backoffice-backend.acrosstour.tech";
export const filesURL = "https://backoffice-backend.acrosstour.tech/public/temporary";

export const imageURL = (path) => path ? `${filesURL}/${path}` : null;

const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
